/** @internal */ export function abortable(promise) {
    const controller = new AbortController();
    return Object.assign(promise, {
        abort: ()=>controller.abort()
        ,
        signal: controller.signal
    });
}
/** @internal */ export function getCookieValue(cookies, name, fallback) {
    const value = cookies.split('; ').find((row)=>row.startsWith(`${name}=`)
    )?.split('=')[1];
    return value ? decodeURIComponent(value) : fallback;
}
